import React from 'react';

const SafeIcon = ({ icon: IconComponent, className = '', ...props }) => {
  if (!IconComponent) {
    return <span className={`inline-block w-5 h-5 bg-gray-400 ${className}`} {...props} />;
  }
  
  return <IconComponent className={className} {...props} />;
};

export default SafeIcon;